import { useQuery } from '@tanstack/react-query';
import { create as createStore } from 'zustand';

import { sdk } from '@/services';

const INITIAL_PAGE = 1;
const INITIAL_LIMIT = 10;

const TagService = sdk.getService('TagService');

interface IStore {
  page: number;
  limit: number;
  search: string;
  setSearch: (search: string) => void;
  setPageAndLimit: (page: number, limit: number) => void;
}

const store = createStore<IStore>(set => ({
  page: INITIAL_PAGE,
  limit: INITIAL_LIMIT,
  search: '',
  setSearch: (search: string) => set(state => ({ ...state, search, page: INITIAL_PAGE })),
  setPageAndLimit: (page: number, limit: number) => set(state => ({ ...state, page, limit }))
}));

export const useTagsByCoursesList = () => {
  const { page, limit, search, setSearch, setPageAndLimit } = store();

  const queryKey = ['tags', 'tags-with-courses', `page-${page}`, `limit-${limit}`, search];
  const { isLoading, data, error } = useQuery({
    queryKey,
    queryFn: () => TagService.getTagsByCourses(search, { page, limit })
  });

  const resetSearchResults = () => setSearch('');

  const pagination = data && {
    page: data.page,
    limit: data.limit,
    hasNextPage: data.hasNextPage,
    hasPrevPage: data.hasPrevPage,
    nextPage: data.nextPage,
    pagingCounter: data.pagingCounter,
    prevPage: data.prevPage,
    totalDocs: data.totalDocs,
    totalPages: data.totalPages
  };

  return {
    tagsWithCourses: data?.docs,
    isLoading,
    error,
    setPageAndLimit,
    pagination,
    setSearch,
    search,
    resetSearchResults
  };
};
